export const pkd = {
  "pkd.getFiles": "pkd.getFiles",
  "pkd.deleteFile": "pkd.deleteFile",
  "pkd.uploadFile": "pkd.uploadFile",
  "pkd.editFile": "pkd.editFile",
  "pkd.getThree": "pkd.getThree",
  "pkd.getCheckLists": "pkd.getCheckLists",
  "pkd.getCheckListComments": "pkd.getCheckListComments",
  "pkd.createCheckListComment": "pkd.createCheckListComment",
} as const;
